import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DateTime } from "luxon";
import CalendarIcon from "@material-ui/icons/Event";
import { anyNotBlank, notBlank } from "../common/general";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const useStyles = marginTop =>
  makeStyles(theme => ({
    root: {
      marginTop: marginTop,
    },

    input: {
      marginTop: 16,
    },

    helperTextRtl: {
      textAlign: "right",
    },

    formControlRtl: {
      right: 0,
    },

    inputLabelRtl: {
      transformOrigin: "top right",
    },
  }));

const DatePicker = props => {
  const {
    xs,
    sm,
    md,
    onBlur,
    onChange,
    onAccept,
    value,
    helperText,
    error,
    required = false,
    noLabel = false,
    label = "Publication Date",
    placeholder,
    disableToolbar = true,
    marginTop = 10,
    fullDate = true,
    id = "date-picker-inline",
  } = props;
  const classes = useStyles(marginTop)();
  const { i18n } = useTranslation();

  const wrapGrid = element => {
    if (anyNotBlank([xs, sm, md])) {
      return (
        <Grid item xs={xs || 12} sm={sm || 6} md={md || 6}>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  return wrapGrid(
    <KeyboardDatePicker
      className={classes.root}
      InputProps={
        noLabel
          ? {
              classes: { root: classes.input },
            }
          : {}
      }
      margin="none"
      disableToolbar={disableToolbar}
      fullWidth
      autoOk
      required={required}
      minDate={new Date("01/01/1000")}
      variant="inline"
      format={fullDate ? "MM/dd/yyyy" : "yyyy"}
      views={fullDate ? ["year", "date"] : ["year"]}
      openTo={fullDate ? "date" : "year"}
      id={id}
      label={noLabel ? null : label}
      placeholder={placeholder}
      value={notBlank(value) ? DateTime.fromISO(value).setZone("utc") : null}
      onChange={onChange}
      onAccept={onAccept}
      onBlur={onBlur}
      helperText={helperText}
      error={error}
      keyboardIcon={<CalendarIcon fontSize="small" />}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
      InputLabelProps={{
        classes: {
          root: clsx({
            [classes.inputLabelRtl]: i18n.dir() === "rtl",
          }),
          formControl: clsx({
            [classes.formControlRtl]: i18n.dir() === "rtl",
          }),
          shrink: clsx({
            [classes.inputLabelRtl]: i18n.dir() === "rtl",
          }),
        },
      }}
      FormHelperTextProps={{
        classes: {
          root: clsx({ [classes.helperTextRtl]: i18n.dir() === "rtl" }),
        },
      }}
    />,
  );
};

export default DatePicker;
